(function () {
  "use strict";
  var DEMO = {
      priceCents: 19e3,
      currency: "NZD",
      colours: [
        {
          id: "onyx",
          name: "Onyx Eclipse",
          swatch: "#262b30",
          flag: "Popular",
          img: "",
          tag: "Best Seller",
        },
        {
          id: "sand",
          name: "Coastal Sand",
          swatch: "#cdb393",
          img: "",
          tag: "Mum's Favorite",
        },
        {
          id: "dusk",
          name: "Pacific Dusk",
          swatch: "#5d8893",
          img: "",
          tag: "Nurses' Pick",
        },
      ],
      sizes: {
        men: ["7", "7.5", "8", "8.5", "9", "10", "11", "12", "13"],
        women: [
          "5.5",
          "6.5",
          "7",
          "7.5",
          "8",
          "8.5",
          "9",
          "9.5",
          "10.5",
          "11.5",
        ],
      },
      fomo: {
        onyx: {
          men: { low: "9", selling: ["8", "10", "11"] },
          women: { low: "7", selling: ["6.5", "8", "8.5"] },
        },
        sand: {
          men: { low: "10", selling: ["8", "9", "11"] },
          women: { low: "7.5", selling: ["6.5", "7", "8"] },
        },
        dusk: {
          men: { low: "8.5", selling: ["7.5", "10", "12"] },
          women: { low: "8.5", selling: ["7", "9", "10.5"] },
        },
      },
      soldOut: {
        onyx: { men: ["13"], women: [] },
        sand: { men: ["13"], women: [] },
        dusk: { men: ["13"], women: [] },
      },
      variants: {},
    },
    VIEWS = [
      "On-Foot",
      "In Rain",
      "Side Profile",
      "Top View",
      "Outsole",
      "Packaging",
    ];
  function init(root) {
    root = root || document;
    var $ = function (s, c) {
        return (c || root).querySelector(s);
      },
      $$ = function (s, c) {
        return Array.prototype.slice.call((c || root).querySelectorAll(s));
      },
      reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches,
      desktopGallery = function () {
        return window.matchMedia("(min-width: 900px)").matches;
      };
    if (!$("#pdpStage") && !$(".pdp-buy")) return;
    var DATA =
        window.OSZEA_PDP &&
        window.OSZEA_PDP.colours &&
        window.OSZEA_PDP.colours.length
          ? window.OSZEA_PDP
          : DEMO,
      PRICE_CENTS = DATA.priceCents != null ? DATA.priceCents : DEMO.priceCents,
      COLOURS = DATA.colours,
      SIZES = DATA.sizes,
      FOMO = DATA.fomo || {},
      SOLD_OUT = DATA.soldOut || {},
      VARIANTS = DATA.variants || {},
      CURRENCY = DATA.currency || "NZD",
      variantSelect = $("#pdp-variant-id"),
      productForm = $("#pdp-form");
    function variantKey(c, f, s) {
      return c + "|" + f + "|" + s;
    }
    function variantFor(c, f, s) {
      var v = VARIANTS[variantKey(c, f, s)];
      if (
        (v ||
          (v =
            VARIANTS[c + "|" + f + "|"] ||
            VARIANTS[c + "||" + s] ||
            VARIANTS[c + "||"] ||
            VARIANTS[c]),
        !v && variantSelect)
      ) {
        var options = $$("option", variantSelect),
          opt = options.filter(function (o) {
            var dc = o.getAttribute("data-colour"),
              df = o.getAttribute("data-fit"),
              ds = o.getAttribute("data-size"),
              cMatch = !dc || dc === c || !c,
              fMatch =
                !df || df === f || !f || df === "null" || !$("#pdpGender"),
              sMatch =
                !ds ||
                String(ds) === String(s) ||
                ds === "null" ||
                ds === "" ||
                !s ||
                !$("#pdpSizes");
            return cMatch && fMatch && sMatch;
          })[0];
        (!opt &&
          c &&
          (opt = options.filter(function (o) {
            var dc = o.getAttribute("data-colour");
            return dc === c;
          })[0]),
          !opt && options.length > 0 && (opt = options[0]),
          opt &&
            (v = {
              id: opt.value,
              available: !opt.disabled,
              qty: parseInt(opt.getAttribute("data-qty") || "0", 10),
              priceCents:
                parseInt(opt.getAttribute("data-price") || "0", 10) || null,
            }));
      }
      return v || null;
    }
    var requestedGender = new URLSearchParams(window.location.search).get("gender");
    var state = {
      colour: (COLOURS[0] && COLOURS[0].id) || "onyx",
      gender: requestedGender === "women" ? "women" : "men",
      size: null,
      qty: 1,
      slide: 0,
    };
    function colourObj() {
      return (
        COLOURS.filter(function (c) {
          return c.id === state.colour;
        })[0] ||
        COLOURS[0] ||
        {}
      );
    }
    var SYMBOLS = {
      INR: "\u20B9",
      USD: "$",
      NZD: "$",
      AUD: "$",
      CAD: "$",
      EUR: "\u20AC",
      GBP: "\xA3",
      JPY: "\xA5",
      VND: "\u20AB",
      SGD: "$",
      HKD: "$",
      MYR: "RM",
      PHP: "\u20B1",
      THB: "\u0E3F",
      KRW: "\u20A9",
      CNY: "\xA5",
      TWD: "NT$",
      AED: "AED ",
      ZAR: "R",
      CHF: "CHF ",
    };
    function money(cents) {
      var curr = (
          (window.OSZEA_PDP && window.OSZEA_PDP.currency) ||
          (window.Shopify &&
            window.Shopify.currency &&
            window.Shopify.currency.active) ||
          CURRENCY ||
          (DATA && DATA.currency) ||
          "NZD"
        ).toUpperCase(),
        sym = SYMBOLS[curr] || "$",
        dollars = Number(cents) / 100,
        noDecimals = ["JPY", "KRW", "VND"].indexOf(curr) !== -1,
        formatted;
      return (
        noDecimals
          ? (formatted = Math.round(dollars).toLocaleString("en-US"))
          : curr === "INR"
            ? (formatted =
                dollars % 1 === 0
                  ? dollars.toLocaleString("en-IN")
                  : dollars.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }))
            : (formatted =
                dollars % 1 === 0
                  ? dollars.toLocaleString("en-US")
                  : dollars.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })),
        sym + formatted + " " + curr
      );
    }
    function sizesFor(g) {
      var raw = (SIZES[g] || []).map(function (s) {
        return typeof s == "string" ? s : s.s;
      });
      return raw.filter(function (item, pos) {
        return raw.indexOf(item) == pos;
      });
    }
    function hashStr(str) {
      for (var h = 0, i = 0; i < str.length; i++)
        ((h = (h << 5) - h + str.charCodeAt(i)), (h |= 0));
      return Math.abs(h);
    }
    function seededShuffle(arr, seed) {
      var a = arr.slice(),
        s = seed || 1;
      function rnd() {
        return ((s = (s * 9301 + 49297) % 233280), s / 233280);
      }
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(rnd() * (i + 1)),
          tmp = a[i];
        ((a[i] = a[j]), (a[j] = tmp));
      }
      return a;
    }
    function autoFomoFor() {
      var pool = sizesFor(state.gender).filter(function (s) {
        return soldOutFor().indexOf(s) === -1;
      });
      if (pool.length < 2) return { low: null, selling: [] };
      var seed = hashStr(
          ((DATA && DATA.title) || "") +
            "|" +
            state.colour +
            "|" +
            state.gender,
        ),
        pick = seededShuffle(pool, seed).slice(0, Math.min(4, pool.length));
      return { low: pick[0] || null, selling: pick.slice(1) };
    }
    function fomoFor() {
      return (
        (FOMO[state.colour] && FOMO[state.colour][state.gender]) ||
        autoFomoFor()
      );
    }
    function soldOutFor() {
      return (VARIANTS && Object.keys(VARIANTS).length) || variantSelect
        ? sizesFor(state.gender).filter(function (s) {
            var v = variantFor(state.colour, state.gender, s);
            return v ? !v.available : !1;
          })
        : (SOLD_OUT[state.colour] && SOLD_OUT[state.colour][state.gender]) ||
            [];
    }
    function isSelectedSoldOut() {
      var hasSizes = $("#pdpSizes") && sizesFor(state.gender).length > 0;
      if (hasSizes)
        return !!state.size && soldOutFor().indexOf(state.size) !== -1;
      var v = variantFor(state.colour, state.gender, state.size);
      return v ? !v.available : !1;
    }
    var stage = $("#pdpStage"),
      track = $("#pdpTrack"),
      thumbsWrap = $("#pdpThumbs"),
      dotsWrap = $("#pdpDots"),
      counter = $("#pdpCounter"),
      colourTag = $("#pdpColourTag"),
      stagePrev = $("#pdpStagePrev"),
      stageNext = $("#pdpStageNext"),
      thumbPrev = $("#pdpThumbPrev"),
      thumbNext = $("#pdpThumbNext");
    (stagePrev &&
      stagePrev.addEventListener("click", function () {
        var n = state.slide - 1;
        (n < 0 && (n = (state.slideCount || VIEWS.length) - 1),
          selectSlide(n, !0));
      }),
      stageNext &&
        stageNext.addEventListener("click", function () {
          var n = state.slide + 1;
          (n >= (state.slideCount || VIEWS.length) && (n = 0),
            selectSlide(n, !0));
        }),
      thumbPrev &&
        thumbPrev.addEventListener("click", function () {
          thumbsWrap.scrollBy({ top: -150, behavior: "smooth" });
        }),
      thumbNext &&
        thumbNext.addEventListener("click", function () {
          thumbsWrap.scrollBy({ top: 150, behavior: "smooth" });
        }));
    var stageResizeObserver;
    function syncThumbsHeight() {
      var stage2 = document.getElementById("pdpStage"),
        tWrap = document.querySelector(".pdp-thumbs-wrap");
      (stage2 && tWrap && window.innerWidth >= 900
        ? (tWrap.style.maxHeight = stage2.clientHeight + "px")
        : tWrap && (tWrap.style.maxHeight = ""),
        typeof updateArrows == "function" && updateArrows());
    }
    (window.addEventListener("resize", syncThumbsHeight, { passive: !0 }),
      window.ResizeObserver &&
        ((stageResizeObserver = new ResizeObserver(syncThumbsHeight)),
        document.addEventListener("DOMContentLoaded", function () {
          var stage2 = document.getElementById("pdpStage");
          stage2 && stageResizeObserver.observe(stage2);
        })));
    function updateArrows() {
      if (
        (stagePrev &&
          stagePrev.classList.toggle("visible", state.slideCount > 1),
        stageNext &&
          stageNext.classList.toggle("visible", state.slideCount > 1),
        thumbPrev && thumbNext && thumbsWrap)
      ) {
        var scrollable = thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 5;
        (thumbPrev.classList.toggle(
          "visible",
          scrollable && thumbsWrap.scrollTop > 5,
        ),
          thumbNext.classList.toggle(
            "visible",
            scrollable &&
              thumbsWrap.scrollTop + thumbsWrap.clientHeight <
                thumbsWrap.scrollHeight - 5,
          ));
      }
    }
    (thumbsWrap &&
      thumbsWrap.addEventListener("scroll", updateArrows, { passive: !0 }),
      window.addEventListener("resize", updateArrows, { passive: !0 }));
    function colourImages(col) {
      return col.images && col.images.length
        ? col.images
        : col.img
          ? [col.img]
          : [];
    }
    function buildGallery() {
      if (track) {
        var col = colourObj();
        (colourTag && (colourTag.textContent = col.tag || col.name),
          (track.innerHTML = ""),
          (thumbsWrap.innerHTML = ""),
          (dotsWrap.innerHTML = ""));
        var imgs = colourImages(col),
          views = imgs.length
            ? imgs.map(function (src, i) {
                return { src: src, label: VIEWS[i] || "View " + (i + 1) };
              })
            : VIEWS.map(function (v) {
                return { src: "", label: v };
              });
        (views.forEach(function (view, i) {
          var media = view.src
              ? '<img class="pdp-slide-img" src="' +
                view.src +
                '" alt="' +
                col.name +
                " \u2014 " +
                view.label +
                '" loading="lazy">'
              : '<div class="ph"><span class="ph-label">[ ' +
                col.name.toUpperCase() +
                " \u2014 " +
                view.label.toUpperCase() +
                " ]</span></div>",
            thumbMedia = view.src
              ? '<img class="pdp-thumb-img" src="' +
                view.src +
                '" alt="" loading="lazy">'
              : '<div class="ph"><span class="ph-label">' +
                view.label +
                "</span></div>",
            slide = document.createElement("div");
          ((slide.className = "pdp-slide" + (i === 0 ? " active" : "")),
            (slide.innerHTML = media),
            track.appendChild(slide));
          var th = document.createElement("button");
          ((th.type = "button"),
            (th.className = "pdp-thumb" + (i === 0 ? " active" : "")),
            th.setAttribute("aria-label", col.name + " " + view.label),
            (th.innerHTML = thumbMedia),
            th.addEventListener("click", function () {
              selectSlide(i, !0);
            }),
            th.addEventListener("mouseenter", function () {
              desktopGallery() && selectSlide(i, !1);
            }),
            thumbsWrap.appendChild(th));
          var dot = document.createElement("button");
          ((dot.type = "button"),
            (dot.className = "pdp-dot" + (i === 0 ? " active" : "")),
            dot.setAttribute("aria-label", "Image " + (i + 1)),
            dot.addEventListener("click", function () {
              track.scrollTo({
                left: i * track.clientWidth,
                behavior: reduce ? "auto" : "smooth",
              });
            }),
            dotsWrap.appendChild(dot));
        }),
          (state.slide = 0),
          (state.slideCount = views.length),
          track && (track.scrollLeft = 0),
          thumbsWrap && (thumbsWrap.scrollLeft = 0),
          updateCounter(),
          updateArrows());
      }
    }
    function selectSlide(i, scroll) {
      if (
        ((state.slide = i),
        $$(".pdp-slide", track).forEach(function (s, j) {
          s.classList.toggle("active", j === i);
        }),
        $$(".pdp-thumb", thumbsWrap).forEach(function (t, j) {
          t.classList.toggle("active", j === i);
        }),
        $$(".pdp-dot", dotsWrap).forEach(function (d, j) {
          d.classList.toggle("active", j === i);
        }),
        scroll && !desktopGallery() && track)
      ) {
        var targetSlide = track.children[i];
        targetSlide
          ? track.scrollTo({
              left: targetSlide.offsetLeft,
              behavior: reduce ? "auto" : "smooth",
            })
          : track.scrollTo({
              left: i * track.clientWidth,
              behavior: reduce ? "auto" : "smooth",
            });
      }
      (thumbsWrap &&
        !desktopGallery() &&
        thumbsWrap.children[i] &&
        thumbsWrap.children[i].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        }),
        updateCounter(),
        setTimeout(syncThumbsHeight, 50),
        setTimeout(updateArrows, 100));
    }
    function updateCounter() {
      if (counter) {
        var pad = function (n) {
          return (n < 10 ? "0" : "") + n;
        };
        counter.textContent =
          pad(state.slide + 1) + " / " + pad(state.slideCount || VIEWS.length);
      }
    }
    if (track) {
      var scrollTimeout;
      track.addEventListener(
        "scroll",
        function () {
          if (!desktopGallery()) {
            var slideWidth =
                track.clientWidth ||
                (track.firstElementChild &&
                  track.firstElementChild.offsetWidth) ||
                1,
              idx = Math.round(track.scrollLeft / slideWidth);
            ((idx = Math.max(
              0,
              Math.min((state.slideCount || VIEWS.length) - 1, idx),
            )),
              idx !== state.slide &&
                ((state.slide = idx),
                $$(".pdp-slide", track).forEach(function (s, j) {
                  s.classList.toggle("active", j === idx);
                }),
                $$(".pdp-thumb", thumbsWrap).forEach(function (t, j) {
                  t.classList.toggle("active", j === idx);
                }),
                $$(".pdp-dot", dotsWrap).forEach(function (d, j) {
                  d.classList.toggle("active", j === idx);
                }),
                thumbsWrap &&
                  !desktopGallery() &&
                  thumbsWrap.children[idx] &&
                  (clearTimeout(scrollTimeout),
                  (scrollTimeout = setTimeout(function () {
                    thumbsWrap.children[idx] &&
                      thumbsWrap.children[idx].scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "center",
                      });
                  }, 60))),
                updateCounter()));
          }
        },
        { passive: !0 },
      );
    }
    if (stage) {
      var touchStartX = 0,
        touchStartY = 0,
        touchDiffX = 0,
        touchDiffY = 0,
        isSwiping = !1;
      (stage.addEventListener(
        "touchstart",
        function (e) {
          if (!desktopGallery()) {
            var t = e.touches[0];
            t &&
              ((touchStartX = t.clientX),
              (touchStartY = t.clientY),
              (touchDiffX = 0),
              (touchDiffY = 0),
              (isSwiping = !0));
          }
        },
        { passive: !0 },
      ),
        stage.addEventListener(
          "touchmove",
          function (e) {
            if (!(!isSwiping || desktopGallery())) {
              var t = e.touches[0];
              t &&
                ((touchDiffX = t.clientX - touchStartX),
                (touchDiffY = t.clientY - touchStartY));
            }
          },
          { passive: !0 },
        ),
        stage.addEventListener(
          "touchend",
          function () {
            if (
              !(!isSwiping || desktopGallery()) &&
              ((isSwiping = !1),
              Math.abs(touchDiffX) > 35 &&
                Math.abs(touchDiffX) > Math.abs(touchDiffY))
            ) {
              var count2 = state.slideCount || VIEWS.length;
              if (touchDiffX < 0) {
                var next = Math.min(count2 - 1, state.slide + 1);
                selectSlide(next, !0);
              } else {
                var prev = Math.max(0, state.slide - 1);
                selectSlide(prev, !0);
              }
            }
          },
          { passive: !0 },
        ));
    }
    stage &&
      stage.addEventListener("click", function () {
        desktopGallery() && stage.classList.toggle("zoomed");
      });
    var coloursWrap = $("#pdpColours"),
      colourName = $("#pdpColourName");
    function buildColours() {
      coloursWrap &&
        ((coloursWrap.innerHTML = ""),
        COLOURS.forEach(function (c) {
          var el = document.createElement("button");
          el.type = "button";
          var isColSold = !1;
          if (DATA.variants && Object.keys(DATA.variants).length > 0) {
            isColSold = !0;
            for (var k in DATA.variants)
              if (k.indexOf(c.id + "|") === 0 && DATA.variants[k].available) {
                isColSold = !1;
                break;
              }
          }
          ((el.className =
            "pdp-col" +
            (c.id === state.colour ? " active" : "") +
            (isColSold ? " sold" : "")),
            el.setAttribute("aria-label", c.name));
          var imgs = colourImages(c);
          ((el.innerHTML =
            (c.flag ? '<span class="pdp-col-flag">' + c.flag + "</span>" : "") +
            '<span class="pdp-col-chip">' +
            (imgs.length
              ? '<img class="pdp-col-img" src="' +
                imgs[0] +
                '" alt="' +
                c.name +
                '" loading="lazy">'
              : '<span class="swatch" style="background:' +
                (c.swatch || "#999") +
                '"></span><span class="ph"><span class="ph-label">' +
                c.name +
                "</span></span>") +
            '</span><span class="pdp-col-name">' +
            c.name +
            "</span>"),
            el.addEventListener("click", function () {
              state.colour !== c.id &&
                ((state.colour = c.id),
                $$(".pdp-col", coloursWrap).forEach(function (x) {
                  x.classList.remove("active");
                }),
                el.classList.add("active"),
                colourName && (colourName.textContent = c.name),
                stage && stage.classList.remove("zoomed"),
                buildGallery(),
                buildSizes(),
                updateSummary());
            }),
            coloursWrap.appendChild(el));
        }),
        colourName && (colourName.textContent = colourObj().name));
    }
    function shade(hex, pct) {
      if (!hex || hex[0] !== "#") return hex || "#999";
      var n = parseInt(hex.slice(1), 16),
        r = Math.max(
          0,
          Math.min(255, (n >> 16) + Math.round((255 * pct) / 100)),
        ),
        g = Math.max(
          0,
          Math.min(255, ((n >> 8) & 255) + Math.round((255 * pct) / 100)),
        ),
        b = Math.max(
          0,
          Math.min(255, (n & 255) + Math.round((255 * pct) / 100)),
        );
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    var genderWrap = $("#pdpGender"),
      sizeSys = $("#pdpSizeSys");
    if (genderWrap) {
      $$("button", genderWrap).forEach(function (btn) {
        var selected = btn.getAttribute("data-gender") === state.gender;
        btn.classList.toggle("active", selected);
        btn.setAttribute("aria-selected", selected ? "true" : "false");
      });
      if (sizeSys)
        sizeSys.textContent = "AU / US " + (state.gender === "men" ? "Men" : "Women");
    }
    genderWrap &&
      $$("button", genderWrap).forEach(function (btn) {
        btn.addEventListener("click", function () {
          var g = btn.getAttribute("data-gender");
          state.gender !== g &&
            ((state.gender = g),
            (state.size = null),
            $$("button", genderWrap).forEach(function (b) {
              var on = b === btn;
              (b.classList.toggle("active", on),
                b.setAttribute("aria-selected", on ? "true" : "false"));
            }),
            sizeSys &&
              (sizeSys.textContent =
                "AU / US " + (g === "men" ? "Men" : "Women")),
            buildSizes(),
            updateSummary());
        });
      });
    var sizesWrap = $("#pdpSizes"),
      sizeMsg = $("#pdpSizeMsg"),
      sizeMsgTxt = $("#pdpSizeMsgTxt");
    function buildSizes() {
      if (sizesWrap) {
        sizesWrap.innerHTML = "";
        var fomo = fomoFor(),
          sold = soldOutFor();
        (sizesFor(state.gender).forEach(function (s) {
          var el = document.createElement("button");
          el.type = "button";
          var isSold = sold.indexOf(s) !== -1,
            isLow = !isSold && fomo.low === s,
            isSelling =
              !isSold &&
              !isLow &&
              fomo.selling &&
              fomo.selling.indexOf(s) !== -1,
            scarce = isLow || isSelling;
          ((el.className =
            "pdp-size" +
            (isSold ? " sold" : "") +
            (isLow ? " is-low" : isSelling ? " is-selling" : "") +
            (s === state.size ? " active" : "")),
            (el.textContent = s),
            isSold
              ? ((el.title = "Sold out"),
                el.setAttribute("aria-label", "Size " + s + " \u2014 sold out"))
              : scarce &&
                ((el.title = isLow
                  ? "Low stock \u2014 only a few left"
                  : "Selling fast"),
                (el.innerHTML =
                  s +
                  '<span class="pdp-size-flag">' +
                  (isLow ? "Low" : "Hot") +
                  "</span>")),
            el.addEventListener("click", function () {
              ((state.size = s),
                $$(".pdp-size", sizesWrap).forEach(function (x) {
                  x.classList.remove("active");
                }),
                el.classList.add("active"),
                hideSizeMsg(),
                updateSummary());
            }),
            sizesWrap.appendChild(el));
        }),
          hideSizeMsg(),
          updateSizeFomo());
      }
    }
    function showSizeMsg(t) {
      sizeMsg &&
        ((sizeMsgTxt.textContent = t), sizeMsg.classList.remove("hide"));
    }
    function hideSizeMsg() {
      sizeMsg && sizeMsg.classList.add("hide");
    }
    function fmtSizeList(arr) {
      return arr.length <= 1
        ? arr.join("")
        : arr.length === 2
          ? arr[0] + " & " + arr[1]
          : arr.slice(0, -1).join(", ") + " & " + arr[arr.length - 1];
    }
    function updateSizeFomo() {
      var fomo = $("#pdpSizeFomo");
      if (fomo) {
        var f = fomoFor(),
          low = f.low ? [f.low] : [],
          selling = (f.selling || []).slice(),
          html = "";
        (low.length &&
          (html +=
            "<b>Low stock</b> \u2014 AU " +
            fmtSizeList(low) +
            (low.length > 1 ? " are" : " is") +
            " almost gone."),
          selling.length &&
            (html +=
              (html ? " " : "") +
              "AU " +
              fmtSizeList(selling) +
              (selling.length > 1 ? " are" : " is") +
              " selling fast."),
          html || (html = "Most sizes in stock \u2014 ships from Auckland."),
          fomo.classList.toggle("is-quiet", !low.length));
        var txt = fomo.querySelector(".pdp-size-fomo-txt");
        txt && (txt.innerHTML = html);
      }
    }
    var qtyEl = $("#pdpQty"),
      stickyQtyEl = $("#pdpStickyQty"),
      qtyInput = $("#Quantity");
    function setQty(n) {
      ((state.qty = Math.max(1, Math.min(9, n))),
        qtyEl && (qtyEl.textContent = state.qty),
        stickyQtyEl && (stickyQtyEl.textContent = state.qty),
        qtyInput && (qtyInput.value = state.qty),
        updateSummary());
    }
    var qm = $("#pdpQtyMinus"),
      qp = $("#pdpQtyPlus"),
      sqm = $("#pdpStickyMinus"),
      sqp = $("#pdpStickyPlus");
    (qm &&
      qm.addEventListener("click", function () {
        setQty(state.qty - 1);
      }),
      qp &&
        qp.addEventListener("click", function () {
          setQty(state.qty + 1);
        }),
      sqm &&
        sqm.addEventListener("click", function () {
          setQty(state.qty - 1);
        }),
      sqp &&
        sqp.addEventListener("click", function () {
          setQty(state.qty + 1);
        }));
    var atcPrice = $("#pdpAtcPrice"),
      stickyPrice = $("#pdpStickyPrice"),
      stickyVar = $("#pdpStickyVar"),
      stickyThumb = $("#pdpStickyThumb"),
      stickySize = $("#pdpStickySize");
    function syncVariantId() {
      if (!variantSelect) return null;
      var hasSizes = $("#pdpSizes") && sizesFor(state.gender).length > 0;
      if (hasSizes && !state.size) return null;
      var v = variantFor(state.colour, state.gender, state.size);
      if (v && v.id) {
        variantSelect.value = v.id;
        try {
          variantSelect.dispatchEvent(new Event("change", { bubbles: !0 }));
        } catch (e) {}
      }
      return v;
    }
    function updateSummary() {
      var hasSizes = $("#pdpSizes") && sizesFor(state.gender).length > 0,
        selectedVariant =
          !hasSizes || state.size
            ? variantFor(state.colour, state.gender, state.size)
            : null,
        unitPriceCents =
          selectedVariant && selectedVariant.priceCents != null
            ? selectedVariant.priceCents
            : PRICE_CENTS,
        compareAtCents =
          selectedVariant && selectedVariant.compareAtCents != null
            ? selectedVariant.compareAtCents
            : (DATA && DATA.compareAtCents) || 0,
        totalCents = unitPriceCents * state.qty;
      (atcPrice && (atcPrice.textContent = money(totalCents)),
        stickyPrice && (stickyPrice.textContent = money(totalCents)));
      var pdpPrice = $("#pdpPrice"),
        pdpPriceCompare = $("#pdpPriceCompare"),
        pdpPriceSave = $("#pdpPriceSave");
      if (
        (pdpPrice && (pdpPrice.textContent = money(unitPriceCents)),
        pdpPriceCompare && pdpPriceSave)
      )
        if (compareAtCents > unitPriceCents) {
          ((pdpPriceCompare.textContent = money(compareAtCents)),
            (pdpPriceCompare.style.display = ""));
          var saveCents = compareAtCents - unitPriceCents;
          ((pdpPriceSave.textContent = "Save " + money(saveCents)),
            (pdpPriceSave.style.display = ""));
        } else
          ((pdpPriceCompare.style.display = "none"),
            (pdpPriceSave.style.display = "none"));
      var pdpInstalAmount = $("#pdpInstalAmount");
      if (pdpInstalAmount) {
        var instalCents = Math.round(unitPriceCents / 4);
        pdpInstalAmount.textContent = money(instalCents);
      }
      var genderLab = state.gender === "men" ? "Men" : "Women",
        sizeLab = hasSizes
          ? state.size
            ? "Size " + state.size
            : "Select size"
          : "";
      if (stickyVar) {
        var colName = (colourObj() && colourObj().name) || "",
          parts = [colName, sizeLab].filter(Boolean);
        stickyVar.innerHTML = parts.join('<span class="dotsep">\xB7</span>');
      }
      if (
        (stickyThumb &&
          (colourObj() && colourObj().img
            ? (stickyThumb.style.background =
                "url(" + colourObj().img + ") center/cover no-repeat")
            : (stickyThumb.style.background =
                "linear-gradient(150deg, " +
                ((colourObj() && colourObj().swatch) || "#345") +
                ", " +
                shade((colourObj() && colourObj().swatch) || "#345", -16) +
                ")")),
        stickySize)
      )
        if (hasSizes) {
          var sold = soldOutFor(),
            sfomo = fomoFor();
          ((stickySize.innerHTML =
            '<option value="">Size</option>' +
            sizesFor(state.gender)
              .map(function (s) {
                var so = sold.indexOf(s) !== -1,
                  lo = !so && sfomo.low === s,
                  hot =
                    !so &&
                    !lo &&
                    sfomo.selling &&
                    sfomo.selling.indexOf(s) !== -1;
                return (
                  '<option value="' +
                  s +
                  '"' +
                  (so ? " disabled" : "") +
                  (s === state.size ? " selected" : "") +
                  ">Size " +
                  s +
                  (so
                    ? " \u2014 sold out"
                    : lo
                      ? " \u2014 low stock"
                      : hot
                        ? " \u2014 selling fast"
                        : "") +
                  "</option>"
                );
              })
              .join("")),
            state.size && (stickySize.value = state.size),
            (stickySize.style.display = ""));
        } else stickySize.style.display = "none";
      (syncVariantId(), syncBuyState());
    }
    var atcBtn = $("#pdpAtc"),
      stickyAtcBtn = $("#pdpStickyAtc"),
      buyNowBtn = $("#pdpBuyNow"),
      expressEls = [$(".pdp-express"), $(".pdp-express-btns")];
    function syncBuyState() {
      var notify = isSelectedSoldOut();
      (atcBtn &&
        (atcBtn.classList.toggle("is-notify", notify),
        (atcBtn.disabled = notify)),
        stickyAtcBtn &&
          (stickyAtcBtn.classList.toggle("is-notify", notify),
          (stickyAtcBtn.textContent = notify ? "Out of Stock" : "Add to Cart"),
          (stickyAtcBtn.disabled = notify)),
        buyNowBtn && (buyNowBtn.style.display = notify ? "none" : ""),
        expressEls.forEach(function (e) {
          e && (e.style.display = notify ? "none" : "");
        }));
    }
    stickySize &&
      stickySize.addEventListener("change", function () {
        var v = stickySize.value;
        v && ((state.size = v), buildSizes(), hideSizeMsg(), updateSummary());
      });
    var cartCount = $("#cartCount"),
      cartBtn = $("#cartBtn"),
      count = parseInt((cartCount && cartCount.textContent) || "0", 10) || 0;
    function requireSize() {
      var sizesEl = $("#pdpSizes");
      if (!sizesEl || sizesFor(state.gender).length === 0 || state.size)
        return !0;
      showSizeMsg(
        "Size required — select an available size above before adding to cart.",
      );
      var grp = sizesWrap && sizesWrap.closest(".pdp-group");
      return (
        grp &&
          !reduce &&
          grp.animate(
            [
              { transform: "translateX(0)" },
              { transform: "translateX(-6px)" },
              { transform: "translateX(6px)" },
              { transform: "translateX(0)" },
            ],
            { duration: 320 },
          ),
        sizesWrap &&
          sizesWrap.scrollIntoView({
            behavior: reduce ? "auto" : "smooth",
            block: "center",
          }),
        !1
      );
    }
    function bumpCart(n) {
      ((count += n),
        cartCount &&
          ((cartCount.textContent = count), cartCount.classList.add("show")),
        cartBtn &&
          (cartBtn.classList.remove("bump"),
          cartBtn.offsetWidth,
          cartBtn.classList.add("bump")),
        typeof window.updateOszeaCartCount == "function" &&
          setTimeout(window.updateOszeaCartCount, 200));
    }
    function addToCart(e) {
      if (isSelectedSoldOut()) {
        (e && e.preventDefault(), openNotifyModal());
        return;
      }
      if (!requireSize()) {
        e && e.preventDefault();
        return;
      }
      var v = syncVariantId(),
        itemTitle =
          (DATA && DATA.title) ||
          ($(".pdp-title") && $(".pdp-title").textContent.trim()) ||
          "Product",
        colName = (colourObj() && colourObj().name) || "",
        sizeText = state.size ? " \xB7 AU " + state.size : "";
      if (productForm && v && v.id) {
        if (productForm.getAttribute("data-ajax") === "true") {
          (e && e.preventDefault(),
            fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ id: v.id, quantity: state.qty }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function () {
                (bumpCart(state.qty),
                  toast(
                    "Added " +
                      state.qty +
                      " \xD7 " +
                      itemTitle +
                      (colName ? " \xB7 " + colName : "") +
                      sizeText,
                  ),
                  document.dispatchEvent(new CustomEvent("oszea:cart:add")));
              })
              .catch(function () {
                productForm.submit();
              }));
          return;
        }
        return;
      }
      var variantIdToUse =
        (v && v.id) || (variantSelect && variantSelect.value);
      if (variantIdToUse) {
        (e && e.preventDefault(),
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ id: variantIdToUse, quantity: state.qty }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              (bumpCart(state.qty),
                toast(
                  "Added " +
                    state.qty +
                    " \xD7 " +
                    itemTitle +
                    (colName ? " \xB7 " + colName : "") +
                    sizeText,
                ),
                document.dispatchEvent(new CustomEvent("oszea:cart:add")));
            })
            .catch(function () {
              productForm && productForm.submit();
            }));
        return;
      }
      (e && e.preventDefault(),
        bumpCart(state.qty),
        toast(
          "Added " +
            state.qty +
            " \xD7 " +
            itemTitle +
            (colName ? " \xB7 " + colName : "") +
            sizeText,
        ));
    }
    (atcBtn && atcBtn.addEventListener("click", addToCart),
      stickyAtcBtn && stickyAtcBtn.addEventListener("click", addToCart),
      productForm &&
        productForm.addEventListener("submit", function (e) {
          if (isSelectedSoldOut()) {
            e.preventDefault();
            return;
          }
          if (!requireSize()) {
            e.preventDefault();
            return;
          }
          syncVariantId();
        }),
      buyNowBtn &&
        buyNowBtn.addEventListener("click", function (e) {
          if (isSelectedSoldOut()) {
            e.preventDefault();
            return;
          }
          if (!requireSize()) {
            e.preventDefault();
            return;
          }
          (syncVariantId(),
            productForm || toast("Redirecting to express checkout\u2026"));
        }),
      (function () {
        var addon = $("#pdpAddon");
        if (addon) {
          var packs = $("#addonPacks"),
            colors = $("#addonColors"),
            priceEl = $("#pdpAddonPrice"),
            addBtn = $("#pdpAddonAdd"),
            sel = { pack: "1", price: 9, color: "White" };
          (packs &&
            $$("button", packs).forEach(function (b) {
              b.addEventListener("click", function () {
                ($$("button", packs).forEach(function (x) {
                  x.classList.toggle("active", x === b);
                }),
                  (sel.pack = b.getAttribute("data-pack")),
                  (sel.price = parseInt(b.getAttribute("data-price"), 10) || 9),
                  priceEl && (priceEl.textContent = "$" + sel.price));
              });
            }),
            colors &&
              $$("button", colors).forEach(function (b) {
                b.addEventListener("click", function () {
                  ($$("button", colors).forEach(function (x) {
                    x.classList.toggle("active", x === b);
                  }),
                    (sel.color = b.getAttribute("data-color") || "White"));
                });
              }),
            addBtn &&
              addBtn.addEventListener("click", function () {
                fetch("/products/oszea-crew-socks.js")
                  .then(function (r) {
                    return r.ok ? r.json() : null;
                  })
                  .then(function (prod) {
                    var matchedVariant = null;
                    return (
                      prod &&
                        prod.variants &&
                        (matchedVariant =
                          prod.variants.find(function (v) {
                            var title = (v.title || "").toLowerCase();
                            return (
                              title.includes(sel.color.toLowerCase()) &&
                              (title.includes(sel.pack + " pack") ||
                                title.includes(sel.pack + "-pack") ||
                                prod.variants.length === 1)
                            );
                          }) || prod.variants[0]),
                      matchedVariant && matchedVariant.id
                        ? fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Accept: "application/json",
                            },
                            body: JSON.stringify({
                              id: matchedVariant.id,
                              quantity: 1,
                            }),
                          })
                        : Promise.resolve()
                    );
                  })
                  .catch(function () {})
                  .finally(function () {
                    (bumpCart(1),
                      addBtn.classList.add("added"),
                      (addBtn.innerHTML = "Added \u2713"),
                      setTimeout(function () {
                        (addBtn.classList.remove("added"),
                          (addBtn.innerHTML =
                            'Add <b id="pdpAddonPrice">$' + sel.price + "</b>"),
                          (priceEl = $("#pdpAddonPrice")));
                      }, 1400),
                      toast(
                        "Added OSZEA Crew Socks \xB7 " +
                          sel.pack +
                          "-Pack \xB7 " +
                          sel.color +
                          " \xB7 $" +
                          sel.price,
                      ),
                      document.dispatchEvent(
                        new CustomEvent("oszea:cart:add"),
                      ));
                  });
              }));
        }
      })(),
      (function () {
        var triggers = document.querySelectorAll(
          "[data-afterpay-modal-trigger]",
        );
        if (!triggers.length) return;
        var modal = document.getElementById("afterpayModal");
        modal ||
          ((modal = document.createElement("div")),
          (modal.id = "afterpayModal"),
          (modal.className = "afterpay-modal-backdrop"),
          modal.setAttribute("role", "dialog"),
          modal.setAttribute("aria-modal", "true"),
          modal.setAttribute("aria-hidden", "true"),
          (modal.innerHTML =
            '<div class="afterpay-modal-panel"><button type="button" class="afterpay-modal-close" data-afterpay-close aria-label="Close modal">\xD7</button><div class="afterpay-modal-header"><div class="afterpay-modal-badge"><span class="afterpay-brand-lg">afterpay</span><svg class="afterpay-icon-lg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0C5.373 0 0 5.373 0 12c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12 0-6.627-5.372-12-12-12Zm1.236 4.924a2.21 2.21 0 0 1 1.15.299l4.457 2.557c1.495.857 1.495 3.013 0 3.87l-4.457 2.558c-1.488.854-3.342-.22-3.342-1.935v-.34a.441.441 0 0 0-.66-.383L6.287 13.9a.441.441 0 0 0 0 .765l4.096 2.35a.44.44 0 0 0 .661-.382v-.685c0-.333.36-.542.649-.376l1.041.597a.441.441 0 0 1 .222.383v.29c0 1.715-1.854 2.789-3.342 1.935L5.157 16.22c-1.495-.857-1.495-3.013 0-3.87l4.457-2.558c1.488-.854 3.342.22 3.342 1.935v.34c0 .34.366.551.66.383l4.097-2.35a.441.441 0 0 0 0-.765l-4.096-2.351a.441.441 0 0 0-.661.382v.685c0 .333-.36.541-.649.375l-1.041-.597a.442.442 0 0 1-.222-.383v-.29c0-1.285 1.043-2.21 2.192-2.233z"/></svg></div><h3>Pay in 4 interest-free payments</h3></div><div class="afterpay-modal-steps"><div class="ap-step"><span class="ap-num">1</span><div><h4>Select Afterpay</h4><p>Choose Afterpay at checkout with your NZ or AU debit or credit card.</p></div></div><div class="ap-step"><span class="ap-num">2</span><div><h4>Instant Decision</h4><p>Quick, hassle-free approval in seconds \u2014 no long forms.</p></div></div><div class="ap-step"><span class="ap-num">3</span><div><h4>4 Equal Payments</h4><p>Pay 25% today, and 25% every 2 weeks. 0% interest when paid on time.</p></div></div></div><div class="afterpay-modal-footer"><p>You must be 18+ and a resident of NZ or AU. Late fees may apply.</p></div></div>'),
          document.body.appendChild(modal));
        function openModal(e) {
          (e && e.preventDefault(),
            modal.classList.add("is-open"),
            modal.setAttribute("aria-hidden", "false"),
            (document.body.style.overflow = "hidden"));
        }
        function closeModal() {
          (modal.classList.remove("is-open"),
            modal.setAttribute("aria-hidden", "true"),
            (document.body.style.overflow = ""));
        }
        (triggers.forEach(function (btn) {
          btn.addEventListener("click", openModal);
        }),
          modal.addEventListener("click", function (e) {
            (e.target.hasAttribute("data-afterpay-close") ||
              e.target === modal) &&
              closeModal();
          }),
          document.addEventListener("keydown", function (e) {
            e.key === "Escape" &&
              modal.classList.contains("is-open") &&
              closeModal();
          }));
      })());
    var openNotifyModal = function () {};
    (function () {
      var modal = $("#notifyModal");
      if (!modal) return;
      var form = $("#notifyForm"),
        variantLine = $("#nmVariantLine"),
        variantSw = $("#nmVariantSw"),
        variantProd = $("#nmVariantProd"),
        fieldProduct = $("#nmFieldProduct"),
        fieldVariant = $("#nmFieldVariant"),
        lastFocus = null;
      function variantText() {
        return (
          (state.gender === "men" ? "Men" : "Women") +
          " \xB7 AU " +
          (state.size || "\u2014") +
          " \xB7 " +
          colourObj().name
        );
      }
      function open() {
        ((lastFocus = document.activeElement),
          variantLine && (variantLine.textContent = variantText()),
          variantSw &&
            (variantSw.style.background = colourObj().swatch || "#345"),
          variantProd &&
            (variantProd.textContent = DATA.title || "Tasman Essentials"),
          fieldProduct &&
            (fieldProduct.value = DATA.title || "Tasman Essentials"),
          fieldVariant && (fieldVariant.value = variantText()),
          modal.classList.add("open"),
          modal.setAttribute("aria-hidden", "false"),
          (document.body.style.overflow = "hidden"));
        var first = modal.querySelector('input[name="contact[Name]"]');
        first &&
          !reduce &&
          setTimeout(function () {
            first.focus();
          }, 80);
      }
      function close() {
        (modal.classList.remove("open"),
          modal.setAttribute("aria-hidden", "true"),
          (document.body.style.overflow = ""),
          lastFocus && lastFocus.focus && lastFocus.focus());
      }
      ((openNotifyModal = open),
        $$("[data-notify-close]", modal).forEach(function (b) {
          b.addEventListener("click", close);
        }),
        document.addEventListener("keydown", function (e) {
          e.key === "Escape" && modal.classList.contains("open") && close();
        }),
        form &&
          form.addEventListener("submit", function (e) {
            if (form.getAttribute("data-demo") === "true") {
              e.preventDefault();
              var email = form.querySelector('input[name="contact[Email]"]');
              if (email && !email.value.trim()) {
                email.focus();
                return;
              }
              (close(),
                toast(
                  "Thanks! We'll email you when " +
                    variantText() +
                    " is back in stock.",
                ));
            }
          }));
    })();
    var toastZone = $("#toastZone") || document.getElementById("toastZone");
    function toast(msg) {
      var zone = document.getElementById("toastZone");
      if (zone) {
        var t = document.createElement("div");
        ((t.className = "toast"),
          (t.innerHTML =
            '<span class="tk"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m5 13 4 4L19 7"/></svg></span><span>' +
            msg +
            "</span>"),
          (t.style.cursor = "pointer"),
          t.setAttribute("role", "link"),
          t.setAttribute("tabindex", "0"),
          t.addEventListener("click", function () {
            window.location.href = "/cart";
          }),
          t.addEventListener("keydown", function (e) {
            (e.key === "Enter" || e.key === " ") &&
              (e.preventDefault(), (window.location.href = "/cart"));
          }),
          zone.appendChild(t),
          requestAnimationFrame(function () {
            t.classList.add("show");
          }),
          setTimeout(function () {
            (t.classList.remove("show"),
              setTimeout(function () {
                t.remove();
              }, 400));
          }, 2600));
      }
    }
    (function () {
      var el = $("#pdpDelivery");
      if (!el) return;
      var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        mons = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
      function add(d) {
        var x = new Date();
        return (x.setDate(x.getDate() + d), x);
      }
      var a = add(3),
        b = add(6),
        sameMonth = a.getMonth() === b.getMonth();
      el.textContent =
        days[a.getDay()] +
        " " +
        a.getDate() +
        (sameMonth ? "" : " " + mons[a.getMonth()]) +
        " \u2013 " +
        days[b.getDay()] +
        " " +
        b.getDate() +
        " " +
        mons[b.getMonth()];
    })();
    function bindAccordion(scope, sel, singleOpen) {
      if (scope) {
        var items = $$(sel, scope);
        (items.forEach(function (item) {
          var head = $("button", item),
            body = item.querySelector(
              sel.indexOf("faq") > -1 ? ".pdp-faq-a" : ".pdp-acc-body",
            );
          if (!head || !body) return;
          function set(open) {
            (item.classList.toggle("open", open),
              (body.style.maxHeight = open ? body.scrollHeight + "px" : "0px"));
          }
          (set(item.classList.contains("open")),
            head.addEventListener("click", function () {
              var willOpen = !item.classList.contains("open");
              (singleOpen &&
                willOpen &&
                items.forEach(function (other) {
                  if (other !== item) {
                    other.classList.remove("open");
                    var ob = other.querySelector(
                      sel.indexOf("faq") > -1 ? ".pdp-faq-a" : ".pdp-acc-body",
                    );
                    ob && (ob.style.maxHeight = "0px");
                  }
                }),
                set(willOpen));
            }));
        }),
          window.addEventListener(
            "resize",
            function () {
              items.forEach(function (item) {
                if (item.classList.contains("open")) {
                  var body = item.querySelector(
                    sel.indexOf("faq") > -1 ? ".pdp-faq-a" : ".pdp-acc-body",
                  );
                  body && (body.style.maxHeight = body.scrollHeight + "px");
                }
              });
            },
            { passive: !0 },
          ));
      }
    }
    (bindAccordion($("#pdpAcc"), ".pdp-acc-item", !1),
      bindAccordion($("#pdpFaq"), ".pdp-faq-item", !0));
    var openSizeModal = function () {};
    ((function () {
      var modal = $("#sgModal"),
        tabs = $("#pdpSGTabs");
      if (!tabs) return;
      var sysWrap = $("#sfSystems"),
        valWrap = $("#sfValues"),
        resultBox = $("#sfResult"),
        resultSize = $("#sfResultSize"),
        resultConv = $("#sfResultConv"),
        resultCta = $("#sfResultCta"),
        curGender = "men",
        curSys = "aus",
        picked = null;
      function rows() {
        var body = $('.pdp-sizetable-body[data-sgbody="' + curGender + '"]');
        return body
          ? $$("tbody tr", body).map(function (tr) {
              var td = $$("td", tr);
              return {
                aus: td[0].textContent.trim(),
                uk: td[1].textContent.trim(),
                eu: td[2].textContent.trim(),
                cm: td[3].textContent.replace(/[^\d.]/g, ""),
                tr: tr,
              };
            })
          : [];
      }
      function clearMatch() {
        $$(".pdp-sizetable tr.sf-match").forEach(function (t) {
          t.classList.remove("sf-match");
        });
      }
      function buildChips() {
        valWrap &&
          ((valWrap.innerHTML = ""),
          (picked = null),
          resultBox && (resultBox.hidden = !0),
          clearMatch(),
          rows().forEach(function (r) {
            var btn = document.createElement("button");
            ((btn.className = "sf-val"),
              (btn.type = "button"),
              (btn.textContent = r[curSys]),
              btn.addEventListener("click", function () {
                ($$(".sf-val", valWrap).forEach(function (x) {
                  x.classList.remove("active");
                }),
                  btn.classList.add("active"),
                  (picked = r),
                  showResult(r));
              }),
              valWrap.appendChild(btn));
          }));
      }
      function showResult(r) {
        (clearMatch(),
          r.tr.classList.add("sf-match"),
          resultSize && (resultSize.textContent = r.aus),
          resultConv &&
            (resultConv.innerHTML =
              '<div class="sf-conv-item"><span class="k">UK</span><span class="v">' +
              r.uk +
              '</span></div><div class="sf-conv-item"><span class="k">EU</span><span class="v">' +
              r.eu +
              '</span></div><div class="sf-conv-item"><span class="k">JP (cm)</span><span class="v">' +
              r.cm +
              "</span></div>"),
          resultBox && (resultBox.hidden = !1));
      }
      (sysWrap &&
        $$("button", sysWrap).forEach(function (b) {
          b.addEventListener("click", function () {
            ((curSys = b.getAttribute("data-sys")),
              $$("button", sysWrap).forEach(function (x) {
                x.classList.toggle("active", x === b);
              }),
              buildChips());
          });
        }),
        $$(".pdp-sizetable-tab", tabs).forEach(function (tab) {
          tab.addEventListener("click", function () {
            ((curGender = tab.getAttribute("data-sg")),
              $$(".pdp-sizetable-tab", tabs).forEach(function (t) {
                t.classList.toggle("active", t === tab);
              }),
              $$(".pdp-sizetable-body").forEach(function (bd) {
                bd.classList.toggle(
                  "active",
                  bd.getAttribute("data-sgbody") === curGender,
                );
              }),
              buildChips());
          });
        }),
        resultCta &&
          resultCta.addEventListener("click", function () {
            if (picked) {
              var gBtn = $(
                '#pdpGender button[data-gender="' + curGender + '"]',
              );
              gBtn && !gBtn.classList.contains("active") && gBtn.click();
              var pill = $$("#pdpSizes .pdp-size").filter(function (p) {
                return (
                  p.textContent.trim().replace(/Sold|Low|Hot/g, "") ===
                  picked.aus
                );
              })[0];
              (pill && pill.click(), closeModal());
              var buy = $(".pdp-buy");
              (buy &&
                buy.scrollIntoView({
                  behavior: reduce ? "auto" : "smooth",
                  block: "start",
                }),
                toast(
                  "Size selected \u2014 " +
                    (curGender === "men" ? "Men" : "Women") +
                    " AU " +
                    picked.aus,
                ));
            }
          }));
      function syncGenderTab(g) {
        ((curGender = g === "women" ? "women" : "men"),
          $$(".pdp-sizetable-tab", tabs).forEach(function (t) {
            t.classList.toggle(
              "active",
              t.getAttribute("data-sg") === curGender,
            );
          }),
          $$(".pdp-sizetable-body").forEach(function (bd) {
            bd.classList.toggle(
              "active",
              bd.getAttribute("data-sgbody") === curGender,
            );
          }));
      }
      function openModal() {
        modal &&
          (syncGenderTab(state.gender),
          modal.classList.add("open"),
          modal.setAttribute("aria-hidden", "false"),
          (document.body.style.overflow = "hidden"),
          buildChips());
      }
      function closeModal() {
        modal &&
          (modal.classList.remove("open"),
          modal.setAttribute("aria-hidden", "true"),
          (document.body.style.overflow = ""));
      }
      ((openSizeModal = openModal),
        $$("[data-sizeguide-open]").forEach(function (b) {
          b.addEventListener("click", openModal);
        }),
        modal &&
          $$("[data-sizeguide-close]", modal).forEach(function (b) {
            b.addEventListener("click", closeModal);
          }),
        document.addEventListener("keydown", function (e) {
          e.key === "Escape" &&
            modal &&
            modal.classList.contains("open") &&
            closeModal();
        }),
        buildChips());
    })(),
      (function () {
        var bar = $("#pdpSticky"),
          anchor = $("#pdpAtc"),
          final = $(".pdp-final");
        if (!bar || !anchor) return;
        function update() {
          var aRect = anchor.getBoundingClientRect(),
            pastBuyBox = aRect.bottom < 60,
            atFinal = final
              ? final.getBoundingClientRect().top < window.innerHeight - 80
              : !1;
          bar.classList.toggle("show", pastBuyBox && !atFinal);
        }
        (window.addEventListener("scroll", update, { passive: !0 }),
          window.addEventListener("resize", update, { passive: !0 }),
          update());
      })());
    var sg = $("#pdpSizeGuide");
    sg &&
      sg.addEventListener("click", function () {
        openSizeModal();
      });
    var fs = $("#pdpFinalSize");
    fs &&
      fs.addEventListener("click", function () {
        openSizeModal();
      });
    var nsz = $("#pdpNurseSize");
    nsz &&
      nsz.addEventListener("click", function () {
        openSizeModal();
      });
    var nshop = $("#pdpNurseShop");
    nshop &&
      nshop.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
      });
    var fshop = $("#pdpFinalShop");
    (fshop &&
      fshop.addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
      }),
      (function () {
        (document.addEventListener(
          "click",
          function (e) {
            var btn = e.target.closest(
              ".pdp-page button, .pdp-page .btn, .pdp-sticky button, .oszea-pdp button, .oszea-pdp .btn",
            );
            !btn ||
              btn.disabled ||
              btn.getAttribute("aria-disabled") === "true" ||
              (btn.classList.remove("oszea-flash"),
              btn.offsetWidth,
              btn.classList.add("oszea-flash"));
          },
          !0,
        ),
          document.addEventListener("animationend", function (e) {
            e.animationName === "oszeaFlash" &&
              e.target.classList.remove("oszea-flash");
          }));
      })(),
      (function () {
        $$(".jdg-rev-carousel").forEach(function (car) {
          var track2 = $(".jdg-rev-track", car),
            prev = $(".jdg-rev-prev", car),
            next = $(".jdg-rev-next", car),
            card = $(".jdg-rev-card", track2);
          if (!track2 || !card) return;
          function step() {
            return card.getBoundingClientRect().width + 16;
          }
          function update() {
            var max = track2.scrollWidth - track2.clientWidth - 2;
            (prev && (prev.disabled = track2.scrollLeft <= 2),
              next && (next.disabled = track2.scrollLeft >= max));
          }
          (prev &&
            prev.addEventListener("click", function () {
              track2.scrollBy({
                left: -step(),
                behavior: reduce ? "auto" : "smooth",
              });
            }),
            next &&
              next.addEventListener("click", function () {
                track2.scrollBy({
                  left: step(),
                  behavior: reduce ? "auto" : "smooth",
                });
              }),
            track2.addEventListener("scroll", update, { passive: !0 }),
            update());
        });
      })(),
      qtyInput && (qtyInput.value = state.qty),
      buildGallery(),
      buildColours(),
      buildSizes(),
      updateSummary());
  }
  (document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", function () {
        init(document);
      })
    : init(document),
    document.addEventListener("shopify:section:load", function (e) {
      init(e.target || document);
    }));
})();
//# sourceMappingURL=/cdn/shop/t/30/assets/oszea-product.js.map
